import React from 'react';
import Immutable from 'immutable';
import c from 'classnames';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
  ImageFromField,
} from '@uncinc/react-drupal-core';

import { WysiwygField } from '../../../components';

import {
  SCREEN_TABLET,
  SCREEN_NORMAL,
} from '../../../config/constants';

import './style.scss';

const ParagraphImage = ({ id, entity }) => {
  const image = entity.getIn(['field_media_item', 0], Immutable.List());
  const imageCaption = image.getIn(['entity', 'field_caption', 0, 'value'], null);
  const body = entity.getIn(['field_body', 0, 'value'], null);
  const fullWidth = entity.getIn(['field_full_width', 0, 'value'], false);
  const originalAspectRatio = entity.getIn(['field_original_aspect_ratio', 0, 'value'], false);
  const showOriginalSize = entity.getIn(['field_show_original_size', 0, 'value'], false);
  const imageStyleNormal = originalAspectRatio ? 'image_original_scaled_medium' : '4_3';
  const imageStyleNormalFullWidth = originalAspectRatio ? 'image_original_scaled_large' : 'wide';
  // Link is temporary, see ticket: https://uncinc.monday.com/boards/1506051082/pulses/9122787009.
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);

  const ParagraphImageClassnames = c('ParagraphImage__image', {
    'ratio_4_3': !originalAspectRatio,
    'ParagraphImage__showOriginalSize': showOriginalSize,
  });

  const ImageRender = (
    <ImageFromField
      className={ParagraphImageClassnames}
      field={image}
      imageStyles={!showOriginalSize && Immutable.Map({
        [SCREEN_TABLET]: originalAspectRatio ? 'image_orignal_scaled' : '4_3_mobile',
        [SCREEN_NORMAL]: fullWidth ? imageStyleNormalFullWidth : imageStyleNormal,
      })}
    />
  );

  return (
    <Container id={id} className="Paragraph ParagraphImage">
      <div className="row">
        <div className={`ParagraphImage__inner col-12 ${fullWidth && !showOriginalSize ? '' : 'col-md-10 col-lg-8'}`}>
          {link ? (
            <CoreLink href={link} aria-label={linkTitle}>
              <div className="ParagraphImage__inner__link_wrapper">
                {ImageRender}
              </div>
            </CoreLink>
          ) : (
            ImageRender
          )}
          {(body || imageCaption) && (
            <div className="ParagraphImage__caption">
              <WysiwygField
                property="schema:text"
                className="ParagraphText__body"
                html={body || imageCaption}
              />
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphImage;
